/**
 * 원문('들린 내용') 가림 — **화면에서만** 감추는 사용자별 설정.
 *
 * 용도는 배려다: 회의 화면을 상대측과 같이 볼 때, 상대 발언의 인식 원문
 * (오인식 포함)이 그대로 보이는 것이 실례가 될 수 있다. 그래서 이 설정은
 * **시각만** 다룬다:
 *
 *   · 텍스트는 DOM 에 그대로 남는다 — 선택·복사·회의록·스크린리더가 평소와
 *     같다. "기록은 다 남는다" 가 요구 사항이다.
 *   · **높이를 바꾸지 않는다** — 줄을 제거하면 카드 높이가 변해 토글 순간
 *     피드 전체가 재배치된다(상대 앞에서 화면이 움찔거린다). color:
 *     transparent(styles/global.css 의 .caption-src-veiled)는 기하를 그대로
 *     두므로 스크롤 보정조차 필요 없다.
 *
 * 방의 상태가 아니라 **이 브라우저의 취향**이다(feed-order 와 같은 규율):
 * 서버 왕복 없음, 호스트·뷰어 독립 저장, 참가자 각자가 자기 화면만 바꾼다.
 */

export type VeilRole = 'host' | 'viewer'

/** 호스트·뷰어가 **각자** 기억한다 — 한 사람이 두 역할을 오갈 수 있다. */
export function veilStorageKey(role: VeilRole): string {
  return `omnitrans:veil-source:${role}`
}

/** 저장값 해석 — '1' 만 가림이다(없거나 깨진 값은 기본값 = 표시). */
export function parseVeil(raw: unknown): boolean {
  return raw === '1'
}
